// extracted by mini-css-extract-plugin
export default {"frame":"_OXEs","preview":"OFeCO","previewValid":"vnrcG","iconWrapper":"nECZn","previewInvalid":"j_DK0","icon":"ACHh3","previewImg":"Eknx0","inner":"DBKMR","name":"mLFfz"};